module.exports = __webpack_public_path__ + "img/jd.c82b7d4a.png";